import React, { memo } from 'react';
// import '@style/modules/project/integrationNavigator.scss';
import '../../../../styles/modules/project/integrationNavigator.scss';
import ExecutiveSummary from './index';
import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import { shouldScrollInToView } from '@components/directUser/utils';
import { findParentNode } from '@utils/common';

const ExecutiveSummaryWrap = (props) => {
  const { id, titleName, identifier, ...rest } = props;
  return (
    <div className="integration-navigator integration-tile executive-summary">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 40,
        }}
      >
        <div className="title executive-summary-title">
          <span>{titleName || 'Executive Summary'}</span>
        </div>
        <div className="button-with-comment-icon">
          <SectionComment
            module="Project Home"
            component={titleName}
            sendIdentifier={identifier}
            getPopupContainer={(triggerNode) =>
              findParentNode(triggerNode, 'executive-summary')
            }
            placement="leftTop"
          />
        </div>
      </div>

      <ExecutiveSummary projectId={id} identifier={identifier} {...rest} />
    </div>
  );
};
export default memo(
  CommentAnchor(ExecutiveSummaryWrap, {
    shouldScrollInToView,
    getAnchorIdFromProp(props) {
      return props?.identifier;
    },
  }),
);
